export default {
  searchConnectionPlaceholder: 'Search'
}